import { StateCreator } from 'zustand'

import Species from '@/enums/species'

const defaultState = {
  isActive: true,
  isDirty: false,
  filters: {
    currentlyFostered: false,
    includeDeceased: false,
    readyForAdoption: false,
    species: undefined as Species | undefined,
    viewAll: false,
    volunteerId: undefined as string | undefined,
  },
}

type BasicFilters = typeof defaultState

export interface BasicFiltersSlice {
  basicFilters: BasicFilters
  setBasicFilters: (filters: BasicFilters) => void
  resetBasicFilters: () => void
}

export const createBasicFilterSlice: StateCreator<BasicFiltersSlice> = (
  set
  // We deep copy here to protect against unintentional mutations of the module level default state from calling code
) => ({
  basicFilters: {
    ...defaultState,
    filters: {
      ...defaultState.filters,
    },
  },
  setBasicFilters: ({
    isActive,
    filters: {
      currentlyFostered,
      includeDeceased,
      readyForAdoption,
      species,
      viewAll,
      volunteerId,
    },
  }: BasicFilters) => {
    set({
      basicFilters: {
        isActive,
        // isDirty should be true if any of the filters are different from the default
        isDirty: !(
          currentlyFostered === defaultState.filters.currentlyFostered &&
          includeDeceased === defaultState.filters.includeDeceased &&
          readyForAdoption === defaultState.filters.readyForAdoption &&
          species === defaultState.filters.species &&
          viewAll === defaultState.filters.viewAll &&
          volunteerId === defaultState.filters.volunteerId
        ),
        filters: {
          currentlyFostered,
          includeDeceased,
          readyForAdoption,
          species,
          viewAll,
          volunteerId,
        },
      },
    })
  },
  resetBasicFilters: () => {
    set((state) => ({
      basicFilters: {
        ...defaultState,
        isActive: state.basicFilters.isActive,
      },
    }))
  },
})
